import { createContext } from 'react';

const GlassStructureContext = createContext();

export default GlassStructureContext;
